var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeofence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H12.9967L0 12.8333V14H0.976111L14 0.976111V0Z",
    fill: "#636F7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03778 0L0 8.94444V10.8889L11.0172 0H9.03778Z",
    fill: "#636F7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08667 0.0311111L0 5.02056V7L7 0L5.08667 0.0311111Z",
    fill: "#636F7C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.11611 0L0 1.16667V3.11111L3.09556 0H1.11611Z",
    fill: "#636F7C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.95605L2.95557 14.0005H4.93501L14 4.9355V2.95605Z",
    fill: "#636F7C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 6.91895L6.91846 14.0006H8.8979L14.0001 8.89839V6.91895Z",
    fill: "#636F7C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 10.8779L10.8774 14.0007H12.8569L14.0002 12.8574V10.8779Z",
    fill: "#636F7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofence);
export default __webpack_public_path__ + "static/media/Geofence.4d313b28bb0b9118972192b2af686f9f.svg";
export { ForwardRef as ReactComponent };